import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default React.memo(props => (
  <SvgIcon {...props} width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.1667 5.16669C13.1667 4.89054 12.9428 4.66669 12.6667 4.66669H10V4.50002C10 3.4875 9.17925 2.66669 8.16671 2.66669H7.83337C6.82083 2.66669 6.00004 3.4875 6.00004 4.50002V4.66669H3.33337C3.05723 4.66669 2.83337 4.89054 2.83337 5.16669C2.83337 5.44283 3.05723 5.66669 3.33337 5.66669H4.04163L4.56269 11.6589C4.64507 12.6063 5.43818 13.3334 6.38913 13.3334H9.61097C10.5619 13.3334 11.355 12.6062 11.4374 11.6588L11.9584 5.66669H12.6667C12.9428 5.66669 13.1667 5.44283 13.1667 5.16669ZM7.83337 3.66669C7.37312 3.66669 7.00004 4.03978 7.00004 4.50002V4.66669H9.00004V4.50002C9.00004 4.03978 8.62696 3.66669 8.16671 3.66669H7.83337ZM10.4411 11.5723L10.9547 5.66669H5.04541L5.55893 11.5722C5.59637 12.0028 5.95686 12.3334 6.38913 12.3334H9.61097C10.0432 12.3334 10.4037 12.0028 10.4411 11.5723Z"
      fill="currentColor"
    />
  </SvgIcon>
));
